import request from "../network/request";

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig() {
  return request({
    url: "/wechat/config",
    params: { url: encodeURIComponent(document.location.href) },
    method: "get",
    dataType: "json"
  });
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
 export function wechatAuth(code, ref_id, login_type) {

  return request({
    url: "/wechat/auth",
    params: {code: code, ref_id: ref_id},
    method: "get",
    dataType: "json"
  });
}




// WEBPACK FOOTER //
// ./src/network/public.js